module.exports = {
  "country": "IE",
  "artist": "Johnny Logan",
  "song": "What´s Another Year",
  "year": "1980",
  "place": "1",
  "spotify": "51hipIpHYmj2Qh2tyQ32h6"
};